import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as formActions } from 'react-redux-form';
import configCardActions from 'actions/configCardActions';
import preLoaderActions from 'actions/preLoaderActions';
import cardImagesActions from 'actions/cardImagesActions';
import debitCardActions from 'actions/debitCardActions';
import { recordAndSavePage } from 'actions/errorViewNavigation';
import { RELIABLE } from 'utilities/uTagging';
import { PATH_SELECT_CARD } from 'constants/uTagConstants/paths';
import UtagHelper from 'utilities/utagHelper';
import { CardSelectorView } from './cardSelectorView';
import cryptoJS from 'crypto-js';
import modalCancelActions from 'actions/modalCancelActions';
import { getGA4EventKeys } from 'utilities/ga4';

const CardSelectorViewContainerComponent = props => {
    useEffect(() => {
        const { userProfile, products, cardImagesActions, immStepsState, recordAndSavePage } = props;
        cardImagesActions.getDebitCards();
        const JointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);
        const docNumberEncrypted = userProfile.docNumber ? cryptoJS.SHA256(userProfile.docNumber).toString() : '';
        !immStepsState.get('welcomeCard') &&
            recordAndSavePage(
                PATH_SELECT_CARD,
                userProfile.recordId,
                userProfile.userId,
                userProfile.product,
                products.get('productsDescription'),
                userProfile.promoCode ? userProfile.promoCode : '',
                JointHolderInfo,
                '',
                '',
                userProfile.investmentType,
                {
                    ...getGA4EventKeys({
                        eventName: 'step_card_selection',
                        pageName: '/onboarding/step5/cardSelection',
                        processDetail: 'cardSelection',
                        onboardingType: userProfile.investmentType,
                    }),
                    identificadorOnboarding: docNumberEncrypted,
                    processStep: 'step5',
                    onboardingR: userProfile.clientRisk,
                    onboardingIdMethod: RELIABLE[userProfile.identityMethod],
                }
            );
        window.scrollTo(0, 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <CardSelectorView {...props} />;
};

CardSelectorViewContainerComponent.propTypes = {
    userProfile: PropTypes.object.isRequired,
    products: PropTypes.object.isRequired,
    cardImagesActions: PropTypes.object.isRequired,
    immStepsState: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
    return {
        userProfile: state.userProfile,
        immStepsState: state.steps,
        errorState: state.error,
        cardImages: state.cardImages,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        cardImagesActions: bindActionCreators(cardImagesActions, dispatch),
        debitCardActions: bindActionCreators(debitCardActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        configCardActions: bindActionCreators(configCardActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        modalCancelActions: bindActionCreators(modalCancelActions, dispatch),
        recordAndSavePage: bindActionCreators(recordAndSavePage, dispatch),
    };
};

export const CardSelectorViewContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(CardSelectorViewContainerComponent);
